import { Routes } from '@angular/router';
import { authGuard } from './core/guard/auth/auth.guard';
import { SessionResolver } from './core/resolver/session.resolver';
import { errorFullPageGuard } from './error-full-page/guard/error-full-page.guard';

export const routes: Routes = [
  {
    path: 's/:code',
    loadComponent: () =>
      import('./redirect/pages/redirect/redirect.component').then(c => c.RedirectComponent)
  },

  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },

  {
    path: 'login',
    resolve: { session: SessionResolver },
    loadComponent: () =>
      import('./otp-page/pages/otp-page/otp-page.component').then(c => c.OtpPageComponent)
  },

  {
    path: 'actions',
    canActivate: [authGuard],
    resolve: { session: SessionResolver },
    loadChildren: () =>
      import('./rp-actions/pages/rp-actions.routes').then(c => c.RP_ACTIONS_ROUTES)
  },

  {
    path: 'result',
    loadComponent: () =>
      import('./result-page/result-page.component').then(c => c.ResultPageComponent)
  },

  {
    path: 'error',
    canActivate: [errorFullPageGuard],
    loadComponent: () =>
      import('./error-full-page/pages/error-full-page/error-full-page.component').then(
        c => c.ErrorFullPageComponent
      )
  }
];
